import React from 'react';
import createSvgIcon from '@material-ui/icons/utils/createSvgIcon';

export default createSvgIcon(
  <path d="M12 20.9996L3.847 13.2406C2.656 12.1076 2 10.5986 2 8.9916C2 7.3846 2.656 5.8756 3.847 4.7416C6.067 2.6286 9.552 2.4386 12 4.1686C14.448 2.4386 17.933 2.6286 20.153 4.7416C21.344 5.8756 22 7.3846 22 8.9916C22 10.5986 21.344 12.1076 20.153 13.2406L12 20.9996Z" />,
  'HeartFull'
);
